<template>
  <v-app>
    <Navbar :voltar="true" app />
    <Sidebar />
    <v-main>
      <v-card class="container" style="min-height: 78vh !important">
        <v-stepper
          v-model="currentStep"
          :elevation="0"
          :items="['Falecido', 'Moderador', 'Despedida']"
          ref="stepper"
          v-if="!loading"
        >
          <template v-slot:item.1>
            <v-card flat>
              <v-container>
                <v-card
                  class="mx-auto"
                  max-width="1000"
                  min-height="64vh"
                  elevation="1"
                >
                  <v-toolbar color="#343F53">
                    <v-card-title
                      class="headline font-weight-bold d-flex align-center justify-space-between px-4 w-100"
                    >
                      <spam style="color: white">Falecido</spam>
                      <v-btn
                        color="white"
                        small
                        class="mr-2"
                        style="font-weight: bold"
                        @click="localizarFalecidos()"
                      >
                        Localizar Falecido
                        <v-icon class="ml-2" dark>mdi-magnify</v-icon>
                      </v-btn>
                    </v-card-title>
                  </v-toolbar>

                  <v-card-text>
                    <v-form v-model="valid">
                      <v-row>
                        <v-col cols="12">
                          <div class="d-flex align-center">
                            <!-- INPUT -->
                            <v-text-field
                              v-model="falecido.nomesocial"
                              :counter="100"
                              :rules="nameRules"
                              label="Apelido *"
                              hide-details
                              required
                              class="custom-text-field flex-grow-1"
                            ></v-text-field>

                            <!-- ÍCONE COM TOOLTIP -->
                            <v-tooltip location="top">
                              <template #activator="{ props }">
                                <v-icon
                                  v-bind="props"
                                  icon="mdi-help-circle-outline"
                                  class="ml-2 mb-6"
                                  size="20"
                                  color="grey"
                                  style="cursor: pointer"
                                />
                              </template>
                              <span>
                                Esse campo será levado em consideração para
                                exibição nas telas de despedida.
                              </span>
                            </v-tooltip>
                          </div>
                        </v-col>

                        <v-col cols="12">
                          <v-text-field
                            v-model="falecido.firstname"
                            :counter="100"
                            :rules="nameRules"
                            label="Nome *"
                            hide-details
                            required
                            readonly
                            class="custom-text-field"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="falecido.birthdate"
                            :rules="dateRules"
                            label="Data de Nascimento *"
                            hide-details
                            required
                            readonly
                            type="date"
                            class="custom-text-field"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="falecido.deathdate"
                            :rules="dateRules"
                            label="Data de Falecimento *"
                            hide-details
                            type="date"
                            readonly
                            class="custom-text-field"
                            required
                          ></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" md="6">
                      <v-text-field
                        label="CEP"
                        v-model="falecido.cep"
                        v-mask="'#####-###'"
                        @blur="consultarCEP"
                        :loading="loadingCEP"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="falecido.birthCountry"
                        label="País de Nascimento"
                        hide-details
                        required
                        class="custom-text-field"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="falecido.birthState"
                        label="Estado de Nascimento"
                        hide-details
                        required
                        class="custom-text-field"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="falecido.birthCity"
                        label="Cidade de Nascimento"
                        hide-details
                        required
                        class="custom-text-field"
                      ></v-text-field>
                    </v-col> -->
                        <v-col cols="12" md="6" class="pb-0">
                          <v-radio-group
                            v-model="falecido.sexo"
                            inline
                            color="blue"
                          >
                            <v-radio
                              label="Masculino"
                              value="Masculino"
                            ></v-radio>
                            <v-radio
                              label="Feminino"
                              value="Feminino"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <div class="user">
                            <v-img
                              :src="
                                falecido.profilePicture || defaultProfilePicture
                              "
                              class="profile-img"
                              @click="$refs.fileInput.click()"
                            />
                            <v-icon
                              class="icon primary white--text"
                              @click="$refs.fileInput.click()"
                              >mdi-upload</v-icon
                            >
                            <input
                              ref="fileInput"
                              type="file"
                              accept="image/*"
                              style="display: none"
                              @change="onFileSelect"
                            />
                          </div>

                          <v-dialog v-model="dialog" width="500">
                            <v-card>
                              <v-card-text>
                                <VueCropper
                                  v-show="selectedFile"
                                  ref="cropper"
                                  :src="selectedFile"
                                  :viewMode="1"
                                  :autoCrop="true"
                                  :autoCropArea="1"
                                  :dragMode="'move'"
                                  :cropBoxResizable="false"
                                  :cropBoxMovable="true"
                                  :background="false"
                                  :ready="onCropperReady"
                                  alt="Imagem selecionada"
                                />
                              </v-card-text>
                              <v-card-actions>
                                <v-btn
                                  outlined
                                  class="primary"
                                  @click="saveImage"
                                  >Recortar</v-btn
                                >
                                <v-btn text @click="dialog = false"
                                  >Cancelar</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-col>

                        <v-col cols="12">
                          <div class="d-flex align-center">
                            <v-switch
                              inset
                              v-model="despedida.showPortal"
                              label="Cadastrar moderador"
                              color="blue"
                            />
                            <v-tooltip location="top">
                              <template #activator="{ props }">
                                <v-icon
                                  v-bind="props"
                                  icon="mdi-help-circle-outline"
                                  class="ml-2 mb-6"
                                  size="20"
                                  color="grey"
                                  style="cursor: pointer"
                                />
                              </template>
                              <span>
                                Ao ativar está opção, será possível moderar a
                                despedida.
                              </span>
                            </v-tooltip>
                          </div>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>

                <v-dialog
                  v-model="dialogFalecido"
                  max-width="1200"
                  min-height="90vh"
                  persistent
                >
                  <v-card>
                    <v-toolbar color="#343F53">
                      <v-card-title class="text-h5 grey lighten-2">
                        <span class="font-weight-bold">Falecidos</span>
                      </v-card-title>
                    </v-toolbar>
                    <v-card-text class="pb-0">
                      <v-card class="pa-4" elevation="0" rounded="lg">
                        <v-row>
                          <v-col cols="6"></v-col>
                          <v-col cols="6" class="px-0 pb-0"
                            ><v-text-field
                              v-model="filtroTable"
                              label="Filtrar"
                              variant="outlined"
                              density="compact"
                              hide-details
                              prepend-inner-icon="mdi-magnify"
                              rounded="lg"
                              class="bg-white"
                          /></v-col>
                        </v-row>
                      </v-card>

                      <v-data-table
                        :items-per-page="itemsPerPage"
                        :headers="headers"
                        :items="cpfResults"
                        :search="filtroTable"
                        items-per-page-text="Falecidos por página"
                        :pageText="'{0}-{1} de {2}'"
                        fixed-header
                        height="58vh"
                        loading-text="Buscando..."
                        :loading="loadingFalecidos"
                      >
                        <template #item.action="{ item }">
                          <v-btn
                            color="#343F53"
                            @click="selectItem(item, 'falecido')"
                            variant="tonal"
                            size="small"
                            >Selecionar</v-btn
                          >
                        </template>

                        <!-- Template para customizar a coluna 'nome' -->
                        <template #item.nome="{ item }">
                          <div style="margin-top: 8px">
                            <strong>
                              <p style="font-size: 16px">
                                {{ item.nome }}
                              </p></strong
                            >
                            <strong>Falecimento:</strong>
                            {{ formatDate(item.falecimento) || "" }} <br />
                            <strong>Nascimento:</strong>
                            {{ formatDate(item.nascimento) || "" }} <br />
                            <strong>Contrato:</strong>
                            {{ item.num_contrato || "" }} -
                            <v-chip
                              size="small"
                              :color="getColor(item.empresa)"
                            >
                              {{ item.empresa }}
                            </v-chip>

                            <br />
                            <strong>Tipo:</strong> {{ item.tipo || "N/A" }}
                            <br />
                            <strong>Cemitério:</strong>
                            {{ item.cemiterio || "" }}
                            <br />
                            <strong>Jazigo:</strong>
                            {{ item.localizacao || "" }}
                          </div>
                        </template>
                        <template #no-data>
                          <div class="text-center py-4 text-medium-emphasis">
                            Nenhum falecido encontrado.
                          </div>
                        </template>
                      </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        @click="limparFiltros()"
                        prepend-icon="mdi-trash-can"
                        color="#343F53"
                        variant="outlined"
                        >Limpar</v-btn
                      >
                      <v-btn
                        @click="
                          dialogFilterFalecido = true;
                          dialogFalecido = false;
                        "
                        color="#343F53"
                        variant="outlined"
                      >
                        <template #prepend>
                          <v-badge
                            dot
                            color="red"
                            v-if="
                              filtros.contrato || filtros.nome || filtros.cpf
                            "
                          >
                            <v-icon icon="mdi-filter-outline" />
                          </v-badge>
                          <v-icon v-else icon="mdi-filter-outline" />
                        </template>
                        Busca Avançada
                      </v-btn>

                      <v-btn
                        @click="dialogFalecido = false"
                        prepend-icon="mdi-close"
                        color="#343F53"
                        variant="elevated"
                        >Fechar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog
                  v-model="dialogFilterFalecido"
                  max-width="600"
                  min-height="40vh"
                  persistent
                >
                  <v-card>
                    <v-toolbar color="#343F53">
                      <v-card-title class="text-h5 grey lighten-2">
                        <span class="font-weight-bold">Pesquisar falecido</span>
                      </v-card-title>
                    </v-toolbar>

                    <v-card-text class="py-0">
                      <p style="margin-top: 0.4rem !important">
                        Preencha um ou mais campos para buscar!
                      </p>
                      <v-card class="pa-4" elevation="0" rounded="lg">
                        <v-row dense>
                          <v-col cols="12" class="pb-4">
                            <v-text-field
                              v-model="filtros.cpf"
                              label="CPF do Titular ou Falecido"
                              prepend-inner-icon="mdi-card-account-details-outline"
                              variant="outlined"
                              density="compact"
                              v-mask="'###.###.###-##'"
                              hide-details
                              rounded="lg"
                              class="bg-white"
                            />
                          </v-col>

                          <v-col cols="12" class="pb-4">
                            <v-text-field
                              v-model="filtros.nome"
                              label="Nome do Falecido"
                              prepend-inner-icon="mdi-account-outline"
                              variant="outlined"
                              density="compact"
                              hide-details
                              rounded="lg"
                              class="bg-white"
                            />
                          </v-col>

                          <v-col cols="12">
                            <v-text-field
                              v-model="filtros.contrato"
                              label="Contrato"
                              prepend-inner-icon="mdi-file-document-outline"
                              variant="outlined"
                              density="compact"
                              hide-details
                              rounded="lg"
                              class="bg-white"
                            />
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        @click="limparFiltros()"
                        prepend-icon="mdi-trash-can"
                        color="#343F53"
                        variant="outlined"
                        size="small"
                        >Limpar</v-btn
                      >
                      <v-btn
                        @click="
                          dialogFilterFalecido = false;
                          dialogFalecido = true;
                          filtros.nome = '';
                          filtros.cpf = '';
                          filtros.contrato = '';
                        "
                        prepend-icon="mdi-arrow-left-thin"
                        color="#343F53"
                        variant="outlined"
                        size="small"
                        >Voltar</v-btn
                      >

                      <v-btn
                        @click="buscarFalecidosFilter()"
                        prepend-icon="mdi-magnify"
                        color="#343F53"
                        variant="elevated"
                        size="small"
                        >Buscar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-container>
            </v-card>
          </template>

          <template v-slot:item.2>
            <v-card flat>
              <v-container class="container">
                <v-card class="mx-auto" max-width="1000" elevation="1">
                  <v-toolbar color="#343F53">
                    <v-card-title
                      class="headline font-weight-bold d-flex align-center justify-space-between px-4 w-100"
                    >
                      <spam style="color: white">Moderador</spam>
                    </v-card-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-form v-model="valid" class="pa-4">
                      <v-row dense>
                        <template v-if="!codigoEnviado">
                          <v-col cols="2"> </v-col>
                          <v-col cols="6" md="6">
                            <v-text-field
                              :readonly="
                                codigoEnviado ||
                                loadingEnvioCod ||
                                loadingValidCod
                              "
                              v-model="moderador.phone"
                              :rules="phoneRules"
                              label="Telefone do Moderador"
                              hide-details
                              v-mask="'(##) #####-####'"
                              required
                              class="custom-text-field"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col
                            cols="2"
                            md="2"
                            class="d-flex align-center justify-center pl-4"
                          >
                            <!-- Botão Iniciar Cadastro -->
                            <v-btn
                              color="#343F53"
                              :disabled="loadingEnvioCod"
                              @click="enviarToken"
                              size="small"
                              variant="outlined"
                              class="mr-2"
                              :loading="loadingEnvioCod"
                            >
                              Iniciar Cadastro
                            </v-btn>
                          </v-col>
                        </template>

                        <!-- Código de Verificação -->
                        <v-col
                          cols="12"
                          md="12"
                          v-if="isVisibleToken && !isVisible"
                        >
                          <div class="d-flex align-center justify-center">
                            <span
                              >Insira o código de 5 dígitos que enviamos para o
                              telefone {{ moderador.phone }}</span
                            >
                          </div>
                          <v-otp-input
                            v-model="moderador.token"
                            :disabled="loadingValidCod"
                            :length="5"
                            class="custom-otp-input"
                            hide-details
                            required
                          ></v-otp-input>
                        </v-col>

                        <v-col
                          cols="12"
                          class="d-flex justify-center"
                          v-if="!isVisible"
                        >
                          <template v-if="codigoEnviado">
                            <v-btn
                              @click="reiniciarCadastro()"
                              color="#343F53"
                              size="small"
                              variant="outlined"
                              class="mr-2"
                              :disabled="loadingValidCod"
                            >
                              Alterar telefone
                            </v-btn>
                            <!-- Botão Reenviar Código -->
                            <v-btn
                              color="#343F53"
                              :disabled="
                                isWaiting || loadingEnvioCod || loadingValidCod
                              "
                              @click="enviarToken"
                              size="small"
                              variant="outlined"
                              class="mr-2"
                              :loading="loadingEnvioCod"
                            >
                              {{
                                isWaiting
                                  ? `Reenviar (${tempoRestante}s)`
                                  : "Reenviar Código"
                              }}
                            </v-btn>
                          </template>
                          <v-btn
                            v-if="isVisibleToken"
                            color="#343F53"
                            @click="verificarToken()"
                            size="small"
                            variant="flat"
                            :disabled="loadingValidCod"
                            :loading="loadingValidCod"
                          >
                            Validar Código
                          </v-btn>
                        </v-col>

                        <template v-if="isVisible">
                          <v-col cols="12">
                            <v-text-field
                              v-model="moderador.nome"
                              :rules="nameRules"
                              label="Nome"
                              hide-details
                              required
                              class="custom-text-field"
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" md="6">
                            <v-text-field
                              :disabled="moderadorExistente"
                              v-model="moderador.email"
                              :rules="emailRules"
                              label="E-mail do Moderador"
                              hide-details
                              required
                              class="custom-text-field"
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" md="6">
                            <v-text-field
                              :disabled="moderadorExistente"
                              v-model="moderador.password"
                              :type="showPassword ? 'text' : 'password'"
                              :rules="passwordRules"
                              label="Senha do Moderador"
                              hide-details
                              required
                              class="custom-text-field"
                            >
                              <template v-slot:append-inner>
                                <v-icon
                                  @click="showPassword = !showPassword"
                                  class="cursor-pointer"
                                >
                                  {{ showPassword ? "mdi-eye-off" : "mdi-eye" }}
                                </v-icon>
                              </template>
                            </v-text-field>
                          </v-col>

                          <v-col cols="12" md="6">
                            <v-select
                              v-model="moderador.cliente"
                              label="Moderador é cliente?"
                              :items="['Sim, cliente do Grupo', 'Ainda não']"
                              required
                            ></v-select>
                          </v-col>

                          <v-col cols="12" md="6">
                            <v-select
                              v-model="moderador.parentesco"
                              label="Parentesco com falecido?"
                              :items="['Não informado', 'Sim', 'Não']"
                              clearable
                              required
                            ></v-select>
                          </v-col>

                          <v-col
                            cols="12"
                            md="6"
                            v-if="moderador.parentesco === 'Sim'"
                          >
                            <v-autocomplete
                              v-model="moderador.tipoParentesco"
                              label="Qual o parentesco?"
                              :items="[
                                'Pai',
                                'Mãe',
                                'Filho(a)',
                                'Irmão(ã)',
                                'Avô(ó)',
                                'Tio(a)',
                                'Sobrinho(a)',
                                'Primo(a)',
                                'Cônjuge',
                                'Amigo(a)',
                                'Outros',
                              ]"
                              clearable
                              required
                            ></v-autocomplete>
                          </v-col>
                        </template>
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-card>
          </template>

          <template v-slot:item.3>
            <v-card flat>
              <v-container class="container">
                <v-card class="mx-auto" max-width="1000" elevation="1">
                  <v-toolbar color="#343F53">
                    <v-card-title
                      class="headline font-weight-bold d-flex align-center justify-space-between px-4 w-100"
                    >
                      <spam style="color: white">Despedida</spam>
                    </v-card-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-form v-model="valid">
                      <v-row>
                        <v-col cols="12">
                          <div class="d-flex align-center">
                            <v-switch
                              inset
                              label="Cadastrar cerimônia na capela?"
                              color="green"
                              hide-details
                              v-model="controleCerimonia"
                            ></v-switch>
                            <v-tooltip location="top">
                              <template #activator="{ props }">
                                <v-icon
                                  v-bind="props"
                                  icon="mdi-help-circle-outline"
                                  class="ml-2"
                                  size="20"
                                  color="grey"
                                  style="cursor: pointer"
                                />
                              </template>
                              <span>
                                Ao ativar está opção, será possível vincular
                                está despedida a uma capela.
                              </span>
                            </v-tooltip>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row v-if="controleCerimonia" class="pb-4">
                        <v-col cols="12" md="6">
                          <v-select
                            v-model="capela.empresa"
                            :items="unidades"
                            item-title="nome"
                            item-value="sigla"
                            label="Unidade *"
                            hide-details
                            class="custom-text-field"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select
                            :items="capelasDisponiveis"
                            label="Número *"
                            hide-details
                            v-model="capela.capela"
                            class="custom-text-field"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="capela.dataHoraInicial"
                            label="Data e Hora Inicial *"
                            type="datetime-local"
                            hide-details
                            class="custom-text-field"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="capela.dataHoraFinal"
                            label="Data e Hora Final *"
                            type="datetime-local"
                            hide-details
                            class="custom-text-field"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            v-model="despedida.cemiterio"
                            :counter="100"
                            label="Cemitério sepultamento *"
                            hide-details
                            required
                            class="custom-text-field"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="despedida.jazigo"
                            :counter="100"
                            label="Jazigo sepultamento *"
                            hide-details
                            required
                            class="custom-text-field"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="despedida.sepHora"
                            :rules="dateRules"
                            label="Data Sepultamento *"
                            hide-details
                            required
                            type="datetime-local"
                            class="custom-text-field"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="despedida.velorio"
                            :counter="100"
                            label="Local Velório *"
                            hide-details
                            required
                            class="custom-text-field"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="despedida.velHora"
                            :rules="dateRules"
                            label="Data Velório *"
                            hide-details
                            required
                            type="datetime-local"
                            class="custom-text-field"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-col cols="12">
                        <v-textarea
                          v-model="despedida.biografia"
                          label="Biografia"
                          outlined
                          counter="1000"
                          :rules="[
                            (v) =>
                              v.length <= 1000 || 'Máximo de 1000 caracteres',
                          ]"
                          rows="5"
                          placeholder="Escreva uma breve biografia..."
                          no-resize
                        ></v-textarea>
                      </v-col>

                      <v-row>
                        <v-col cols="12" md="6">
                          <v-select
                            v-model="despedida.privacyPost"
                            label="Visualização do Perfil *"
                            :items="['Publica', 'Privada']"
                            required
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-switch
                            v-model="despedida.privacyComments"
                            label="Comentários com moderação"
                            required
                            color="green"
                            inset
                          ></v-switch>
                        </v-col>

                        <v-col cols="12">
                          <v-card elevation="0">
                            <v-radio-group v-model="despedida.banner" column>
                              <v-row dense>
                                <v-col
                                  v-for="(image, index) in images"
                                  :key="index"
                                  cols="12"
                                  md="6"
                                >
                                  <v-card elevation="0">
                                    <v-radio :value="image.id"></v-radio>
                                    <img
                                      :src="
                                        require(`@/assets/pack-banners/${image.id}.jpg`)
                                      "
                                      width="400px"
                                      alt="Imagem de banner"
                                    />
                                  </v-card>
                                </v-col>
                              </v-row>
                            </v-radio-group>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-card>

            <v-dialog v-model="dialogQRCODE" persistent max-width="500">
              <v-card>
                <v-toolbar color="#343F53">
                  <v-card-title class="text-h5 grey lighten-2">
                    <span class="font-weight-bold">QR Code</span>
                  </v-card-title>
                </v-toolbar>

                <v-card-text class="d-flex flex-column align-center pb-0">
                  <qrcode-vue
                    :value="value_qrcode"
                    :size="200"
                    level="H"
                    class="mb-4"
                  />
                  <p class="text-center grey--text">
                    Escaneie o QR Code ou compartilhe com outros!
                  </p>
                </v-card-text>
                <v-text-field
                  v-model="value_qrcode"
                  outlined
                  readonly
                  class="px-4"
                />

                <v-card-actions class="d-flex justify-end">
                  <v-btn
                    class="botao"
                    color="#343F53"
                    @click="
                      dialogQRCODE = false;
                      $router.push('/admin/despedidas');
                    "
                  >
                    <v-icon left>mdi-close-circle</v-icon>
                    Fechar
                  </v-btn>
                  <v-btn
                    class="botao"
                    color="#343F53"
                    @click="copiarLink(value_qrcode)"
                  >
                    <v-icon left dark>mdi-content-copy</v-icon>
                    Copiar
                  </v-btn>
                  <v-btn
                    variant="flat"
                    class="botao"
                    color="#343F53"
                    @click="compartilharQrCode(value_qrcode)"
                  >
                    <v-icon left dark>mdi-share-variant</v-icon>
                    Compartilhar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>

          <template v-slot:actions="{}">
            <v-row
              class="d-flex justify-space-between align-center px-4 mx-8"
              style="height: 60px"
            >
              <v-btn
                v-if="currentStep > 1"
                variant="elevated"
                color="#343F53"
                class="rounded-lg text-white elevation-2"
                @click="backButtonClick()"
              >
                <v-icon start>mdi-arrow-left</v-icon>
                Voltar
              </v-btn>

              <v-btn
                :color="currentStep === 3 ? 'green' : '#343F53'"
                class="rounded-lg text-white elevation-2"
                @click="handleButtonClick()"
              >
                {{ currentStep === 3 ? "Finalizar" : "Próximo" }}
                <v-icon end v-if="currentStep < 3">mdi-arrow-right</v-icon>
                <v-icon end v-else>mdi-check</v-icon>
              </v-btn>
            </v-row>
          </template>
        </v-stepper>
        <v-container v-else-if="loading" class="d-flex justify-center">
          <v-progress-circular
            indeterminate
            color="#343F53"
            size="50"
          ></v-progress-circular>
        </v-container>
        <br />
      </v-card>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
const urlBase = "https://parquedasrecordacoes.com.br";
//const urlBase = 'http://localhost:8080'

import Sidebar from "@/components/restrito/Sidebar.vue";
import Navbar from "@/components/restrito/Navbar.vue";
import { http } from "../../services/config";
import QrcodeVue from "qrcode.vue";
import authHeader from "@/services/auth-header";
import { useToast } from "vue-toastification";
import axios from "axios";
const toast = useToast();

import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import Footer from "./Footer.vue";

export default {
  components: {
    QrcodeVue,
    Navbar,
    VueCropper,
    Sidebar,
    Footer,
  },

  computed: {
    isLastStep() {
      return this.currentStep === this.items.length;
    },
    defaultProfilePicture() {
      if (this.falecido?.sexo?.toLowerCase() === "feminino") {
        return require("@/assets/feminino.png");
      }
      return require("@/assets/masculino.png");
    },
    capelasDisponiveis() {
      // Encontrar o nome da unidade baseado na sigla selecionada
      const unidadeSelecionada = this.unidades.find(
        (u) => u.sigla === this.capela.empresa
      );
      return unidadeSelecionada
        ? this.capelasPorUnidade[unidadeSelecionada.nome] || []
        : [];
    },
  },

  data() {
    return {
      controleCerimonia: true,
      unidades: [
        { nome: "Central de Velórios", sigla: "CV" },
        { nome: "Parque das Flores", sigla: "PF" },
        { nome: "Memorial Parque Maceió", sigla: "ME" },
        { nome: "Cemitério Previda", sigla: "CP" },
        { nome: "Parque do Agreste", sigla: "AM" },
      ],
      capelasPorUnidade: {
        "Memorial Parque Maceió": ["01", "02", "03", "04", "05", "06", "07"],
        "Central de Velórios": ["01", "02", "03", "04"],
        "Parque das Flores": ["01", "02", "03", "04"],
        "Cemitério Previda": ["01", "02", "03"],
        "Parque do Agreste": ["01", "02", "03"],
      },
      capela: {
        id: 0,
        id_despedida: 0,
        empresa: "",
        capela: "",
        dataHoraInicial: "",
        dataHoraFinal: "",
        status: true,
      },
      dialog: false,
      selectedFile: null,
      mime_type: "",
      loadingFalecidos: false,
      loadingCEP: false,
      loadingEnvioCod: false,
      loadingValidCod: false,
      loading: false,
      itemsPerPage: 10,
      showPassword: false,
      validacaoModerador: false,
      moderadorExistente: false,
      isVisibleToken: false,
      codigoEnviado: false,
      isVisible: false,
      isWaiting: false,
      tempoRestante: 0,
      selectedImage: null,
      images: [
        { id: "1" },
        { id: "2" },
        { id: "3" },
        { id: "4" },
        { id: "5" },
        { id: "6" },
        { id: "7" },
        { id: "8" },
        { id: "9" },
        { id: "10" },
        { id: "11" },
        { id: "12" },
      ],
      dialogQRCODE: false,
      value_qrcode: "",
      size: 150,
      currentStep: 1,
      valid: false,
      dialogFalecido: false,
      dialogFilterFalecido: false,
      dialogModerador: false,
      filtroTable: "",
      filtros: {
        cpf: "",
        nome: "",
        contrato: "",
      },
      cpfResults: [],
      idFalecido: 0,
      idModerador: 0,
      falecido: {
        idIvertex: 0,
        firstname: "",
        nomesocial: "",
        birthdate: "",
        deathdate: "",
        birthCity: "",
        birthState: "",
        birthCountry: "",
        sexo: "Masculino",
        profilePicture: "",
        profilePictureFile: null,
      },
      moderador: {
        nome: "",
        phone: "",
        email: "",
        password: "",
        cliente: "",
        parentesco: "",
        token: "",
        tipoParentesco: "",
      },
      despedida: {
        showPortal: true,
        contrato: "",
        cemiterio: "",
        jazigo: "",
        sepHora: "",
        velorio: "",
        velHora: "",
        biografia: "",
        banner: "1",
        privacyPost: "",
        privacyComments: true,
      },
      headers: [
        {
          text: "Informações",
          value: "nome",
          title: "Informações",
          sortable: false,
        },
        { text: "Ações", value: "action", title: "Ações", sortable: false },
      ],
      nameRules: [(v) => !!v || "Nome é obrigatório"],
      dateRules: [(v) => !!v || "Data é obrigatória"],
      cityRules: [(v) => !!v || "Cidade é obrigatória"],
      emailRules: [
        (v) => !!v || "E-mail é obrigatório",
        (v) => /.+@.+\..+/.test(v) || "E-mail deve ser válido",
      ],
      passwordRules: [
        (v) => !!v || "Senha é obrigatória",
        (v) =>
          (v && v.length >= 6) || "A senha deve ter pelo menos 6 caracteres",
      ],
      phoneRules: [(v) => !!v || "Telefone é obrigatório"],
    };
  },

  methods: {
    /**
     * Cadastra ou atualiza os dados da capela associada à despedida
     * Este método realiza as seguintes operações:
     * 1. Verifica se os campos obrigatórios estão preenchidos
     * 2. Consulta se já existe uma capela cadastrada para esta despedida
     * 3. Se existir, atualiza os dados mantendo o ID original
     * 4. Se não existir, cria um novo registro
     * @returns {Promise<void>}
     */
    async cadastrarCapela() {
      try {
        // Associa a despedida à capela
        this.capela.id_despedida = this.idDespedida;

        // Validação inicial dos campos obrigatórios
        if (
          !this.capela.empresa ||
          !this.capela.capela ||
          !this.capela.dataHoraInicial ||
          !this.capela.dataHoraFinal
        ) {
          console.log(this.capela);
          toast.warning("Preencha todos os campos obrigatórios da cerimônia");
          return;
        }

        // 1. Consulta se já existe uma capela cadastrada para esta despedida
        const response = await http.get(
          `apresentacao/despedida/${this.idDespedida}`,
          { headers: authHeader() }
        );

        // 2. Processa os dados retornados da API
        let capelaExistente = null;

        // Verifica se a resposta é um array e se tem elementos
        if (Array.isArray(response.data) && response.data.length > 0) {
          capelaExistente = response.data[0];
        }
        // Verifica se a resposta é um objeto com ID
        else if (response.data && response.data.id) {
          capelaExistente = response.data;
        }

        // 3. Decide entre atualizar ou criar com base na existência prévia
        if (capelaExistente && capelaExistente.id) {
          // Preserva o ID da capela existente
          this.capela.id = capelaExistente.id;

          // Atualiza a capela existente com os novos dados
          await http.put("apresentacao/update", this.capela, {
            headers: authHeader(),
          });

          console.log("Capela atualizada com sucesso");
        } else {
          // Cria uma nova capela
          await http.post("apresentacao/salva", this.capela, {
            headers: authHeader(),
          });

          console.log("Nova capela cadastrada com sucesso");
        }
      } catch (error) {
        // Tratamento específico para erro de capela já vinculada
        if (
          error.response &&
          error.response.status === 400 &&
          error.response.data ===
            "Já existe outro registro ativo para esta empresa"
        ) {
          toast.error(
            "Esta capela já está vinculada a outra cerimônia no horário selecionado"
          );
        } else {
          // Tratamento genérico para outros erros
          toast.error("Erro ao vincular cerimônia à despedida");
          console.error("Detalhes do erro:", error);
        }
      }
    },
    reiniciarCadastro() {
      this.codigoEnviado = false;
      this.isVisibleToken = false;
      this.moderador = {
        phone: "",
        token: "",
        nome: "",
        senha: "",
      };
    },
    getColor(empresa) {
      switch (empresa) {
        case "PARQUE DAS FLORES":
          return "orange darken-2";
        case "CEMITERIO PREVIDA":
          return "blue lighten-1";
        case "MEMORIAL PARQUE MACEIÓ":
          return "green lighten-1";
        case "PARQUE DO AGRESTE":
          return "cyan lighten-1";
        case "PREVIDA":
          return "blue lighten-1";

        default:
          "success";
      }
    },

    limparFiltros() {
      this.filtros.cpf = "";
      this.filtros.nome = "";
      this.filtros.contrato = "";
      this.filtroTable = "";
      this.dialogFilterFalecido = false;
      this.localizarFalecidos();
      toast.success("Consultando os últimos falecidos!");
    },
    localizarFalecidos() {
      this.loadingFalecidos = true;
      this.dialogFalecido = true;
      http
        .get("cliente/pessoas-ivertex-falecidas", {
          headers: authHeader(),
        })
        .then((response) => {
          this.cpfResults = response.data;
          this.loadingFalecidos = false;
        })
        .catch((error) => {
          console.error("Erro ao buscar falecidos:", error);
          this.loadingFalecidos = false;
        });
    },
    buscarFalecidosFilter() {
      if (!this.filtros.cpf && !this.filtros.nome && !this.filtros.contrato) {
        toast.error("Preencha um ou mais campos antes de buscar!");
        return;
      }
      this.dialogFilterFalecido = false;
      this.dialogFalecido = true;
      this.loadingFalecidos = true;
      http
        .get("/cliente/pessoas-ivertex", {
          params: {
            cpf: this.filtros.cpf,
            nome: this.filtros.nome,
            contrato: this.filtros.contrato,
          },
          headers: authHeader(),
        })
        .then((response) => {
          this.cpfResults = response.data;
          this.loadingFalecidos = false;
          if (this.cpfResults.length === 0) {
            toast.warning(
              "Nenhum falecido encontrado com os dados informados!"
            );
          }
        })
        .catch((error) => {
          console.error("Erro ao buscar CPF:", error);
          this.loadingFalecidos = false;
        })
        .finally(() => {
          this.loadingFalecidos = false;
        });
    },
    formatDateTime(value) {
      if (!value) return null;
      const date = new Date(value);
      const pad = (n) => n.toString().padStart(2, "0");

      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = "00"; // fixo

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    onCropperReady() {
      const cropper = this.$refs.cropper.cropper;

      const cropSize = 260;
      const container = cropper.getContainerData();

      cropper.setCropBoxData({
        width: cropSize,
        height: cropSize,
        left: (container.width - cropSize) / 2,
        top: (container.height - cropSize) / 2,
      });
    },
    onFileSelect(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.mime_type = file.type;
      const reader = new FileReader();
      reader.onload = (event) => {
        this.selectedFile = event.target.result;
        this.dialog = true;
      };
      reader.readAsDataURL(file);
    },
    saveImage() {
      const canvas = this.$refs.cropper.getCroppedCanvas();
      if (!canvas) return;

      canvas.toBlob((blob) => {
        if (!blob) return;

        const mimeType = blob.type || this.mime_type || "image/jpeg";
        const extension =
          mimeType.split("/")[1]?.replace("jpeg", "jpg") || "jpg";
        const fileName = `falecido-perfil.${extension}`;

        this.falecido.profilePictureFile = new File([blob], fileName, {
          type: mimeType,
        });

        const reader = new FileReader();
        reader.onloadend = () => {
          // Mantem a preview local enquanto envia o arquivo via multipart.
          this.falecido.profilePicture = reader.result;
          this.dialog = false;
        };
        reader.readAsDataURL(blob);
      }, this.mime_type);
    },
    consultarCEP() {
      const cep = this.falecido.cep.replace(/\D/g, "");
      if (cep.length === 8) {
        this.falecido.birthCountry = "";
        this.falecido.birthCity = "";
        this.falecido.birthState = "";

        this.loadingCEP = true;
        axios
          .get(`https://brasilapi.com.br/api/cep/v1/${cep}`)
          .then((response) => {
            this.falecido.birthCountry = "Brasil";
            this.falecido.birthCity = response.data.city;
            this.falecido.birthState = response.data.state;
          })
          .catch((error) => {
            console.error("Erro ao consultar o CEP:", error);
            toast.error("CEP não localizado!");
          })
          .finally(() => {
            this.loadingCEP = false;
          });
      }
    },
    formatDate(date) {
      if (!date) return "";
      const isoDate = date.split("T")[0];
      const [year, month, day] = isoDate.split("-");
      return `${day}/${month}/${year}`;
    },

    async enviarToken() {
      try {
        const phoneTratado = this.moderador.phone.replace(/\D/g, "");
        this.loadingEnvioCod = true;
        if (!phoneTratado || phoneTratado.length !== 11) {
          toast.error("Informe um número de telefone válido!");
          return;
        }

        const response = await http.post(`validacao/salvar`, null, {
          params: {
            telefone: phoneTratado,
          },
          headers: authHeader(),
        });
        this.idDespedida = response.data.id;
      } catch (error) {
        console.error("Erro ao cadastrar despedida:", error);
        throw error;
      }
      this.loadingEnvioCod = false;
      this.isVisibleToken = true;
      this.codigoEnviado = true;
      this.iniciarTemporizador();
    },

    async verificarEmail() {
      try {
        const response = await http.post(`validacao/verificar-email`, null, {
          params: {
            email: this.moderador.email,
          },
          headers: authHeader(),
        });
        console.log(response.data);
        return response.data;
      } catch (error) {
        console.error("Erro ao validar o token:", error);
        return false;
      }
    },
    async verificarToken() {
      if (!this.moderador.token) {
        toast.error("Informe o código de verificação!");
        return;
      }
      this.loadingValidCod = true;
      const phoneTratado = this.moderador.phone.replace(/\D/g, "");

      // Parar o temporizador ao validar o código
      this.pararTemporizador();

      try {
        const response = await http.post(
          `validacao/verificar`, // Endpoint
          null,
          {
            params: {
              telefone: phoneTratado,
              token: this.moderador.token,
            },
            headers: authHeader(),
          }
        );

        if (response.status === 200 && response.data.mensagem === "Sucesso") {
          toast.success("Código validado!");
          this.codigoValidado = true;
          this.isVisible = true;
          this.validacaoModerador = true;
          this.pararTemporizador();
        } else {
          toast.error("Código incorreto!");
        }

        if (response.data.existente) {
          this.moderador.nome = response.data.pessoa.nome;
          this.moderador.cliente = response.data.pessoa.moderador_cliente;
          this.moderador.parentesco = response.data.pessoa.parentesco_falecido;
          this.idModerador = response.data.pessoa.id;
          this.moderador.tipoParentesco = response.data.pessoa.tipo_parentesco;
          this.moderadorExistente = true;
        }
      } catch (error) {
        console.error("Erro ao validar o token:", error);
        toast.error("Erro ao validar o token!");
      }
      this.loadingValidCod = false;
    },
    iniciarTemporizador() {
      this.isWaiting = true;
      this.tempoRestante = 150;

      // Se já houver um temporizador rodando, limpa ele antes de iniciar um novo
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

      this.intervalId = setInterval(() => {
        if (this.tempoRestante > 0) {
          this.tempoRestante--;
        } else {
          this.isWaiting = false;
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }, 1000);
    },
    pararTemporizador() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      this.isWaiting = false;
      this.tempoRestante = 0;
    },
    selectItem(item, itemType) {
      if (itemType === "falecido") {
        this.falecido.firstname = item.nome;
        this.falecido.nomesocial = item.nome;
        this.falecido.birthdate = item.nascimento;
        this.falecido.deathdate = item.falecimento;
        this.despedida.cemiterio = item.cemiterio;
        this.despedida.jazigo = item.localizacao;
        this.despedida.sepHora = item.dtSepultamento;
        this.despedida.velorio = item.velorio;
        this.despedida.velHora = item.dtVelorio;
        this.despedida.contrato = item.num_contrato;
        this.falecido.sexo = item.sexo;
        this.falecido.idIvertex = item.id;
      } else if (itemType === "moderador") {
        this.moderador.email = item.email || "";
        this.moderador.phone = item.telefone || "";
      }
      if (itemType === "falecido") {
        this.dialogFalecido = false;
      } else if (itemType === "moderador") {
        this.dialogModerador = false;
      }
    },
    removeMask(value) {
      return value.replace(/\D/g, "");
    },
    cleanDataBeforeSearch() {
      this.cpf = this.removeMask(this.cpf);
    },
    finalizarQrCode() {
      this.dialogQRCODE = false;
      this.$router.push("despedidas");
    },
    copiarLink(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {})
        .catch((err) => {
          console.error("Erro ao copiar:", err);
        });
      toast.success("Link copiado para área de transferência!");
    },
    compartilharQrCode(text) {
      if (navigator.share) {
        navigator
          .share({
            title: "QR Code",
            text: "Confira este QR Code:",
            url: text, // URL gerada para o QR Code
          })
          .then(() => {
            console.log("Compartilhamento realizado com sucesso!");
          })
          .catch((error) => {
            console.error("Erro ao compartilhar:", error);
          });
      } else {
        // Caso o navegador não suporte a API de compartilhamento
        this.copiarLink();
        alert(
          "Compartilhamento não suportado neste dispositivo. O link foi copiado para a área de transferência."
        );
      }
    },
    handleButtonClick: async function () {
      if (this.currentStep === 1) {
        if (!this.validateStepOne()) {
          toast.error(
            "Preencha todos os campos obrigatórios antes de avançar."
          );
          return;
        }
        if (!this.despedida.showPortal) {
          this.currentStep = 3;
          return;
        }
      }

      if (this.currentStep === 2) {
        if (this.idModerador == 0) {
          try {
            const emailValido = await this.verificarEmail();
            if (emailValido) {
              toast.error(
                "E-mail já está registrado. Por favor informe outro para cadastro!"
              );
              return;
            }
          } catch (error) {
            console.error("Erro ao verificar o e-mail:", error);
            toast.error("Erro ao verificar o e-mail.");
            return;
          }
        }
        if (!this.validacaoModerador) {
          toast.error("Validação do moderador necessária!");
          return;
        }
      }

      if (this.currentStep === 3) {
        this.finalizarCadastro();
      } else {
        this.currentStep++;
      }
    },
    backButtonClick() {
      if (!this.despedida.showPortal) {
        this.currentStep = 1;
        return;
      }
      this.currentStep--;
    },
    validateStepOne() {
      const { firstname, birthdate, deathdate, sexo } = this.falecido;
      return firstname && birthdate && deathdate && sexo;
    },

    async finalizarCadastro() {
      this.loading = true;

      try {
        await this.cadastrarFalecido();

        if (this.despedida.showPortal && !this.moderadorExistente) {
          await this.cadastrarModerador();
        }

        if (this.despedida.showPortal && this.moderadorExistente) {
          await this.updateModerador();
        }

        await this.cadastrarDespedida();

        if (this.controleCerimonia) {
          await this.cadastrarCapela();
        }

        toast.success("Cadastro finalizado com sucesso!");
        this.dialogQRCODE = true;
        this.loading = false;
      } catch (error) {
        console.error("Erro ao realizar os cadastros:", error);
        this.loading = false;
        toast.error("Erro ao cadastrar. Tente novamente mais tarde!");
      }
    },
    async updateModerador() {
      try {
        if (this.idModerador === 0) {
          return;
        }
        const response = await http.post(
          "cliente/update-pessoa-moderador",
          {
            pessoa: {
              id: this.idModerador,
              nome: this.moderador.nome,
              telefone: this.moderador.phone,
              moderador_cliente: this.moderador.cliente,
              parentesco_falecido: this.moderador.parentesco,
              tipo_parentesco: this.moderador.tipoParentesco,
            },
          },
          {
            headers: authHeader(),
          }
        );
        if (!response) {
          console.log("Finalizado!");
        }
      } catch (error) {
        console.error("Erro ao atualizar moderador:", error);
        throw error;
      }
    },
    async cadastrarFalecido() {
      try {
        const response = await http.post(
          "cliente/nova-pessoa-falecida",
          {
            nome: this.falecido.firstname,
            nome_social: this.falecido.nomesocial,
            data_nascimento: this.falecido.birthdate,
            data_falecimento: this.falecido.deathdate,
            cidade: this.falecido.birthCity,
            estado: this.falecido.birthState,
            pais: this.falecido.birthCountry,
            sexo: this.falecido.sexo,
            id_iVertex: this.falecido.idIvertex,
          },
          {
            headers: authHeader(),
          }
        );
        this.idFalecido = response.data.id;
      } catch (error) {
        console.error("Erro ao cadastrar falecido:", error);
        throw error;
      }
    },

    async cadastrarModerador() {
      try {
        const response = await http.post(
          "cliente/nova-pessoa-moderador",
          {
            username: this.moderador.email,
            password: this.moderador.password,
            pessoa: {
              nome: this.moderador.nome,
              telefone: this.moderador.phone,
              moderador_cliente: this.moderador.cliente,
              parentesco_falecido: this.moderador.parentesco,
              tipo_parentesco: this.moderador.tipoParentesco,
            },
          },
          {
            headers: authHeader(),
          }
        );
        this.idModerador = response.data.id;
      } catch (error) {
        console.error("Erro ao cadastrar moderador:", error);
        throw error;
      }
    },

    async cadastrarDespedida() {
      this.despedida.velHora = this.formatDateTime(this.despedida.velHora);
      this.despedida.sepHora = this.formatDateTime(this.despedida.sepHora);
      try {
        const moderadorId = this.despedida.showPortal ? this.idModerador : null;

        if (this.despedida.showPortal && !moderadorId) {
          throw new Error("Moderador não definido para publicação no portal.");
        }

        const despedidaPayload = {
          foto_fundo: this.despedida.banner,
          obituario: this.despedida.biografia,
          data_sepultamento: this.despedida.sepHora,
          local_sepultamento: this.despedida.cemiterio,
          localizacao_sepultado: this.despedida.jazigo,
          data_velorio: this.despedida.velHora,
          local_velorio: this.despedida.velorio ?? "",
          pessoa_falecida_id: this.idFalecido,
          pessoa_moderador_id: moderadorId,
          funeraria: "Funerária Exemplo Ltda",
          status_memoria: true,
          tipo: this.despedida.privacyPost,
          com_moderacao: this.despedida.privacyComments,
          transmissao: "https://example.com/transmissao",
          codigo_transmissao: "TX123456",
          contrato_jazigo: this.despedida.contrato,
          publicacao: this.despedida.showPortal,
        };

        const formData = new FormData();
        formData.append("despedida", JSON.stringify(despedidaPayload));

        if (this.falecido.profilePictureFile) {
          formData.append("imagemFalecido", this.falecido.profilePictureFile);
        }

        const response = await http.post(
          "cliente/nova-despedida",
          formData,
          {
            headers: authHeader(),
          }
        );
        this.idDespedida = response.data.id;
        this.value_qrcode =
          urlBase + "/despedidas/" + response.data.controle.chave;
      } catch (error) {
        console.error("Erro ao cadastrar despedida:", error);
        throw error;
      }
    },
  },
};
</script>

<style>
.cropper-view-box,
.cropper-face {
  border-radius: 50% !important;
}
</style>

<style scoped>
.v-main {
  background-color: #f5f5f5;
}
.container {
  min-height: 78vh !important;
}

.custom-text-field {
  margin-bottom: 1rem;
}

.custom-file-input {
  margin-top: 1rem;
}

.search {
  margin-bottom: 1rem;
}

.finish {
  margin: 1rem;
}

.qrcode {
  text-align: center;
}

.img-banner {
  width: 300px;
}

.hidden-fields {
  visibility: hidden;
}

.user {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  border: 3px solid #ccc;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.profile-img {
  height: 100%;
  width: 100%;
  border-radius: 50%;
}
.icon {
  position: absolute;
  top: 22px;
  right: 16px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 100%;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}
.icon {
  transition: background 0.3s ease;
}
.icon:hover {
  background: rgba(0, 0, 0, 0.7);
}
</style>
